import { render, staticRenderFns } from "./DrawdownTemp.vue?vue&type=template&id=67d98849&scoped=true&"
import script from "./DrawdownTemp.vue?vue&type=script&lang=js&"
export * from "./DrawdownTemp.vue?vue&type=script&lang=js&"
import style0 from "./DrawdownTemp.vue?vue&type=style&index=0&id=67d98849&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../RetirementPlanner.Demo/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d98849",
  null
  
)

export default component.exports